// Calculate dosage for female hormone balance formula
export function calculateFemaleDosage(answers) {
    // 益母草 (2-3g) - 活血调经
    let yimucao = 2;

    if (answers.mainConcern === 'menstrual') {
        // 基于月经问题类型
        if (answers.menstrualIssues?.includes('dysmenorrhea')) {
            yimucao = 3;
        } else if (answers.menstrualIssues?.includes('light_flow') ||
            answers.menstrualIssues?.includes('irregular_cycle')) {
            yimucao = 2.5;
        }
    } else if (answers.mainConcern === 'fertility') {
        // 备孕调理
        if (answers.fertilityMenstrual === 'very_irregular') {
            yimucao = 3;
        } else if (answers.fertilityMenstrual === 'somewhat_irregular') {
            yimucao = 2.5;
        }
    } else if (answers.mainConcern === 'menopause') {
        // 更年期，月经不规律
        if (answers.menopauseMenstrual === 'irregular') {
            yimucao = 2.5;
        }
    }

    // 香附 (2-3g) - 疏肝理气
    let xiangfu = 2;

    if (answers.mainConcern === 'mood') {
        // 情绪问题为主
        const moodIssueCount = answers.moodIssues?.length || 0;
        if (moodIssueCount >= 3) {
            xiangfu = 3;
        } else if (moodIssueCount >= 1) {
            xiangfu = 2.5;
        }
    } else if (answers.mainConcern === 'menstrual') {
        // 月经前情绪问题
        if (answers.otherSymptoms?.includes('breast_tenderness')) {
            xiangfu = 2.5;
        }
    } else if (answers.mainConcern === 'menopause') {
        // 更年期情绪
        if (answers.menopauseSymptoms?.includes('mood')) {
            xiangfu = 2.5;
        }
    }

    // 压力大也增加香附
    if (answers.stress === 'high') {
        xiangfu = Math.min(3, xiangfu + 0.5);
    }

    // 玫瑰花 (1-2g) - 理气解郁
    let meiguihua = 1;

    const hasLiverQiStagnation =
        answers.otherSymptoms?.includes('breast_tenderness') ||
        answers.moodIssues?.includes('irritable') ||
        answers.moodIssues?.includes('emotional') ||
        answers.mainConcern === 'mood';

    if (hasLiverQiStagnation) {
        const stagnationCount = [
            answers.otherSymptoms?.includes('breast_tenderness'),
            answers.moodIssues?.includes('irritable'),
            answers.moodIssues?.includes('emotional'),
            answers.moodIssues?.includes('anxious')
        ].filter(Boolean).length;

        if (stagnationCount >= 2) {
            meiguihua = 2;
        } else {
            meiguihua = 1.5;
        }
    }

    // 计算总剂量等级
    const total = yimucao + xiangfu + meiguihua;
    let level;
    if (total <= 5.5) level = 'light';
    else if (total <= 6.5) level = 'medium';
    else level = 'heavy';

    return {
        yimucao,
        xiangfu,
        meiguihua,
        level,
        total
    };
}

// Determine review status
export function getFemaleReviewStatus(answers, dosage) {
    // Red flags
    if (answers.safety && !answers.safety.includes('none')) {
        return {
            status: 'red',
            label: 'Professional Review Required',
            message: 'Health risk factors detected, professional review required.'
        };
    }

    if (answers.demographics?.age === 'other') {
        return {
            status: 'red',
            label: 'Professional Review Required',
            message: 'Age factor requires professional confirmation.'
        };
    }

    // Yellow flags
    if (answers.dysmenorrheaSeverity === 'severe') {
        return {
            status: 'yellow',
            label: 'Priority Review',
            message: 'Severe dysmenorrhea, priority assessment recommended.'
        };
    }

    if (answers.menstrualIssues?.includes('heavy_flow')) {
        return {
            status: 'yellow',
            label: 'Priority Review',
            message: 'Heavy menstrual flow, priority assessment recommended.'
        };
    }

    if (answers.fertilityDuration === '>1year') {
        return {
            status: 'yellow',
            label: 'Priority Review',
            message: 'Long duration of trying to conceive, priority assessment recommended.'
        };
    }

    if (answers.menopauseDuration === '>1year' &&
        answers.menopauseSymptoms?.length >= 3) {
        return {
            status: 'yellow',
            label: 'Priority Review',
            message: 'Severe menopause symptoms, priority assessment recommended.'
        };
    }

    // Green
    return {
        status: 'green',
        label: 'Auto Approved',
        message: 'Formula generated, proceeding to production.'
    };
}

// Base formula
export const FEMALE_BASE_FORMULA = [
    { name: 'Angelica root', amount: '2g' },
    { name: 'White Peony Root', amount: '2g' },
    { name: 'Szechuan Lovage Rhizome', amount: '1g' },
    { name: 'Prepared Rehmannia Root', amount: '2g' },
    { name: 'Poria Mushroom', amount: '2g' }
];